import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table as Table2,
    Pagination,
    Checkbox,
    Modal,
    Transfer,
    Form,
    Col,
    Radio,
    Avatar,
    Typography,
    Upload,
    Popconfirm,
    message,
    Mentions,
    Slider,
    Tooltip,
    Cascader,
    Tabs,
    Steps
} from 'antd';
import { Redirect, Link, withRouter } from 'react-router-dom';
import store from "../store/store.js";
import { UserOutlined, DeleteOutlined, FolderAddOutlined, QuestionCircleOutlined, EditOutlined } from '@ant-design/icons'
import 'braft-editor/dist/index.css'
import BraftEditor from 'braft-editor'
import Table from 'braft-extensions/dist/table'
import { ContentUtils } from 'braft-utils'
import { ImageUtils } from 'braft-finder'
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import moment from 'moment';
import GenjinEdit from './genjin_edit.js';



const { Step } = Steps;
const { SHOW_CHILD } = Cascader;
dayjs.extend(customParseFormat);
const { Option } = Select;
const { Text } = Typography;
const options = {
    defaultColumns: 3, // 默认列数
    defaultRows: 3, // 默认行数
    withDropdown: true, // 插入表格前是否弹出下拉菜单
    columnResizable: true, // 是否允许拖动调整列宽，默认false
    exportAttrString: 'border="1" style="border-collapse: collapse"', // 指定输出HTML时附加到table标签上的属性字符串
    // includeEditors: [], // 指定该模块对哪些BraftEditor生效，不传此属性则对所有BraftEditor有效
    // excludeEditors: []  // 指定该模块对哪些BraftEditor无效
}

BraftEditor.use(Table(options))

class Genjin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {
                project_resource_id: props.id,
            }, condition2: {
                project_resource_id: props.id, editorState: BraftEditor.createEditorState(null),
            }, motlist: [], datalist: [], loading: false,
        };
        this.editorInstance = React.createRef();
        this.lthistory = React.createRef();
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    getdata = () => {
        let that = this
        let arr = that.state.condition
        fetch('/ProjectResource/progressList', {
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {

                that.setState({
                    ...data.data

                })
                var div = document.getElementById('lthistory');
                if (data.datalist.length) {
                    // return
                    div.scrollTop = div.scrollHeight;
                }
            })
    }

    componentDidMount() {
        let that = this
        that.getdata()
    }

    onSelChange(name, type, value) {
        let that = this
        console.log(name, value)
        let arr = type == 1 ? this.state.condition : this.state.condition2
        let data = Object.assign({}, arr, { [name]: value })
        if (type == 1) {
            this.setState({
                condition: data
            })
        } else {
            this.setState({
                condition2: data
            })
        }
    }
    editorChange = (editorState) => {
        // console.log(editorState)
        let data = Object.assign({}, this.state.condition2, { editorState: editorState, content: editorState.toHTML() })
        this.setState({
            condition2: data
        })

    }

    onChange(name, type, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let arr = type == 1 ? this.state.condition : this.state.condition2
        let data = Object.assign({}, arr, { [name]: value })
        if (type == 1) {
            this.setState({
                condition: data
            })
        } else {
            this.setState({
                condition2: data
            })
        }
    }

    onCheckboxChange(name, type, e) {
        let that = this
        let value = e.target.checked
        console.log(name, type, value)
        let arr = type == 1 ? this.state.condition : this.state.condition2
        let data = Object.assign({}, arr, { [name]: value })
        if (type == 1) {
            this.setState({
                condition: data
            })
        } else {
            this.setState({
                condition2: data
            })
        }
    }

    // 富文本上传附件
    picChange2(name, info) {
        // console.log(info)
        if (info.file.status === 'uploading') {
            this.setState({ loading2: true });
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            // console.log(info.file.response)
            if (info.file.response.status == 0) {
                message.error(info.file.response.msg)
                return;
            }
            let text = ContentUtils.insertText(this.state.condition2[name], info.file.response.name, ['COLOR-00F', 'UNDERLINE'], {
                type: 'LINK', mutability: 'MUTABLE', data: {
                    href: info.file.response.url, target: '_blank',
                },
            })
            let data = Object.assign({}, this.state.condition2, {
                [name]: text, content: text.toHTML()
            })
            this.setState({
                condition2: data
            })
        }
    };

    delhis = (id, e) => {
        console.log(id, e)
        let that = this
        fetch('/ProjectResource/progressDelete', {
            method: "POST", body: JSON.stringify({
                id: id
            })
        })
            .then(res => res.json())
            .then(data => {

                // return
                if (data.status == 1) {
                    message.success(data.msg)
                    that.getdata()
                } else {
                    message.error(data.msg)
                }
            })
    }
    sub = () => {
        let that = this
        let arr = that.state.condition2
        fetch('/ProjectResource/progressSave', {
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {

                // return
                if (data.status == 1) {
                    message.success(data.msg)
                    that.getdata()
                    that.setState({
                        condition2: {
                            project_resource_id: this.props.id,
                            editorState: BraftEditor.createEditorState(null),
                        },
                    })
                    // if(that.props.type==2){//项目才需要
                    that.props.refresh()
                    // }
                } else {
                    message.error(data.msg)
                }
            })
    }

    //聊天记录显示
    arrltHis(arr) {
        if (arr) {
            return arr.map((item, index) => <div
                className={'item ' + (item.aid == store.getState().data.info.id ? 'i2' : 'i1')} key={index}>
                <div className='l'>
                    <Avatar shape="square" size={45} icon={<UserOutlined />} src={item.tx} />
                </div>
                <div className='neirong'>
                    <div className='up'>
                        <div className='p1'>
                            <Space wrap>
                                {(item.aid == store.getState().data.info.id && item.is_editable == 1) ?
                                    <>
                                        <GenjinEdit
                                            refresh={this.getdata.bind(this)}
                                            id={item.id}
                                            content={item.content}
                                            title={<EditOutlined />}
                                        />
                                        <span className='name'>
                                            <Popconfirm
                                                title="确定删除?"
                                                onConfirm={this.delhis.bind(this, item.id)}
                                                okText="确定"
                                                cancelText="取消"
                                            >
                                                <DeleteOutlined className='del' />
                                            </Popconfirm>
                                        </span>
                                    </>
                                    : null}
                                <span className='name'>
                                    {item.user.name}
                                </span>
                                <span className='name'>
                                    {item.addtime_text}
                                </span>
                            </Space>
                        </div>
                        <div className='p2' dangerouslySetInnerHTML={{ __html: item.content }}></div>
                    </div>
                </div>
            </div>)
        }
    }

    render() {
        //多媒体上传
        const myUploadFn = (param) => {

            const serverURL = '/Ajax/uploads'
            const xhr = new XMLHttpRequest
            const fd = new FormData()

            const successFn = (response) => {
                // 假设服务端直接返回文件上传后的地址
                // 上传成功后调用param.success并传入上传后的文件地址
                let reg = /["\\]/g
                var url = xhr.responseText.replace(reg, "");
                param.success({
                    // url: xhr.responseText,
                    url: url, meta: {
                        // id: 'xxx',
                        // title: 'xxx',
                        // alt: 'xxx',
                        loop: false, // 指定音视频是否循环播放
                        autoPlay: false, // 指定音视频是否自动播放
                        controls: true, // 指定音视频是否显示控制栏
                        poster: '', // 指定视频播放器的封面
                    }
                })
            }

            const progressFn = (event) => {
                // 上传进度发生变化时调用param.progress
                param.progress(event.loaded / event.total * 100)
            }

            const errorFn = (response) => {
                // 上传发生错误时调用param.error
                param.error({
                    msg: 'unable to upload.'
                })
            }

            xhr.upload.addEventListener("progress", progressFn, false)
            xhr.addEventListener("load", successFn, false)
            xhr.addEventListener("error", errorFn, false)
            xhr.addEventListener("abort", errorFn, false)

            fd.append('file', param.file)
            xhr.open('POST', serverURL, true)
            xhr.send(fd)

        }
        const controls = ['undo', 'redo', 'separator', 'font-size', 'line-height', 'letter-spacing', 'separator', 'text-color', 'bold', 'italic', 'underline', 'strike-through', 'separator', 'superscript', 'subscript', 'remove-styles', 'separator', 'text-indent', 'text-align', 'separator', 'headings', 'list-ul', 'list-ol', 'code', 'blockquote', 'table', 'media', 'separator', 'hr', 'link', 'separator', 'separator', 'clear']
        const extendControls = [{
            key: 'antd-uploader', type: 'component', component: (<Upload
                showUploadList={false}
                action="/Ajax/upload"
                onChange={this.picChange2.bind(this, 'editorState')}
            >
                {/* 这里的按钮最好加上type="button"，以避免在表单容器中触发表单提交，用Antd的Button组件则无需如此 */}
                <Button className="control-item button upload-button" data-title="上传附件">
                    <FolderAddOutlined />
                </Button>
            </Upload>)
        }]
        const { mentionKeyword, mentions } = this.state
        return (<>
            {/* <Space>
                <Input className="input" placeholder="内容搜索"
                    value={this.state.condition.keyword ? this.state.condition.keyword : null}
                    onChange={this.onChange.bind(this, 'keyword', 1)} style={{ width: 280 }} autoComplete="off" />
                <Button type="primary" onClick={this.getdata.bind(this)}>搜索</Button>
            </Space> */}
            {/* 聊天记录 */}
            <div className='ltlist' id='lthistory' style={!this.state.datalist.length ? { display: 'none' } : {}}>
                {this.state.datalist.length ? this.arrltHis(this.state.datalist) : null}
            </div>
            <div className='shuru'>
                <div className="editor-wrapper" id='editor' style={{ border: '1px solid #bbb' }}>
                    <BraftEditor
                        value={this.state.condition2.editorState}
                        onChange={this.editorChange}
                        controls={controls}
                        media={{ uploadFn: myUploadFn }}
                        contentStyle={{ height: 250, }}
                        extendControls={extendControls}
                        // onFocus={this.editFocus.bind(this)}
                        ref={instance => this.editorInstance = instance}
                    />

                </div>
                <div style={{ paddingTop: 20 }}>
                    <Row justify="center">
                        <Space>
                            <Button type="primary" onClick={this.sub.bind(this)}>提交</Button>
                        </Space>
                    </Row>
                </div>
            </div>
        </>)
    }
}

export default Genjin
